function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgetsIconOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.15,6.2H12.85A2.85,2.85,0,0,0,10,9.05V33a2.85,2.85,0,0,0,2.84,2.85h16.3A2.85,2.85,0,0,0,32,33V9.05A2.85,2.85,0,0,0,29.15,6.2M13.91,11.12a.87.87,0,0,1,.87-.87H27.23a.87.87,0,0,1,.86.87v1.71a.87.87,0,0,1-.86.87H14.78a.87.87,0,0,1-.87-.87Zm2.92,19.47a.87.87,0,0,1-.87.87H14.78a.87.87,0,0,1-.87-.87v-.82a.87.87,0,0,1,.87-.87H16a.87.87,0,0,1,.87.87Zm0-5.13a.87.87,0,0,1-.87.87H14.78a.87.87,0,0,1-.87-.87v-.82a.87.87,0,0,1,.87-.87H16a.87.87,0,0,1,.87.87Zm5.7,5.13a.87.87,0,0,1-.87.87H20.48a.87.87,0,0,1-.87-.87v-.82a.87.87,0,0,1,.87-.87h1.18a.87.87,0,0,1,.87.87Zm0-5.13a.87.87,0,0,1-.87.87H20.48a.87.87,0,0,1-.87-.87v-.82a.87.87,0,0,1,.87-.87h1.18a.87.87,0,0,1,.87.87Zm0-5.13a.86.86,0,0,1-.87.86H14.78a.86.86,0,0,1-.87-.86v-.82a.87.87,0,0,1,.87-.87h6.88a.87.87,0,0,1,.87.87Zm5.7,10.26a.86.86,0,0,1-.86.87H26.18a.87.87,0,0,1-.87-.87v-.82a.87.87,0,0,1,.87-.87h1.19a.86.86,0,0,1,.86.87Zm0-5.13a.86.86,0,0,1-.86.87H26.18a.87.87,0,0,1-.87-.87v-.82a.87.87,0,0,1,.87-.87h1.19a.86.86,0,0,1,.86.87Zm0-5.13a.85.85,0,0,1-.86.86H26.18a.86.86,0,0,1-.87-.86v-.82a.87.87,0,0,1,.87-.87h1.19a.86.86,0,0,1,.86.87Z",
    style: {
      fill: "#62a3ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetsIconOnboarding);
export default __webpack_public_path__ + "static/media/budgets_icon_onboarding.27f9fa3c11d2c06c9f4c83451fefa7a0.svg";
export { ForwardRef as ReactComponent };